module.exports = __webpack_public_path__ + "media/truth_initiative/truth_background_970x1160-d1e43b44.jpg";